// El registro del service worker del panel (PWA del panel, 28 ago 2026).
//
// Vive en su propio archivo y lo llaman las dos entradas --el login y el tablero-- por lo mismo que
// en el portal: sin service worker el navegador **no ofrece instalar la app**, y el login es la
// pagina en la que uno esta parado la primera vez. Colgado solo del tablero, la unica forma de que
// apareciera el aviso de instalar seria ya haber entrado.
//
// Lo que `publico/sw.js` se niega a cachear --la API, `/docs/` y el HTML-- esta explicado ahi mismo.
export function registrarSW() {
  if (!('serviceWorker' in navigator)) return;
  // Se registra al cargar y sin bloquear nada: si falla, el panel funciona igual.
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('./sw.js').catch((e) => {
      console.warn('El service worker no se registró; el panel funciona igual.', e);
    });
  });
}
